import style from "./TextInput.module.scss"

interface Props {
  value: string
  placeholder?: string
  maxLength?: number
  onChange: (value: string) => void
}

/**
 * Styled component for text input fields
 */
export function TextInput({
  value,
  placeholder,
  maxLength,
  onChange,
}: Props) {
  return <input
    className={style.input}
    value={value}
    placeholder={placeholder}
    maxLength={maxLength}
    onChange={event => onChange(event.target.value)}
    onClick={event => event.preventDefault()}
  />
}